function getLocation(href) {
  // eslint-disable-next-line no-useless-escape
  var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  }
}

export const blogPostBodySerializer = (html) => {
  if (!html) return html

  // eslint-disable-next-line no-use-before-define
  if (typeof DOMParser === 'undefined') {
    var DOMParser = require('xmldom').DOMParser
  }
  
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  
  // look for blog/root URLs, rewrite to use local paths
  const aTags = doc.getElementsByTagName('a')
  Array.prototype.slice.call(aTags).forEach((a, i) => {
    if (!a) { return }
    const location = getLocation(a.getAttribute('href'))
    a.setAttribute('pathname', location.pathname)
    
    if (location.hostname.indexOf('blog.vergesense.com') > -1) {
      a.setAttribute('href', `/resources${a.getAttribute('pathname')}`)
    }

    if (location.hostname === 'vergesense.com') {
      a.setAttribute('href', location.pathname)
    }

    if (location.hostname !== 'vergesense.com' && location.hostname !== 'localhost') {
      a.setAttribute('target', '_blank')
      a.setAttribute('rel', 'noopener noreferrer')
    }
  })

  // look for img tags with alt text, add figcaption
  const imgTags = doc.getElementsByTagName('img')
  // console.log(imgTags)
  
  for (let i = 0; i <= imgTags.length; i++) {
    const img = imgTags[i]
    if (img) {
      const altText = img.getAttribute('alt')
      
      if (altText && altText !== '') {
        let figEle = doc.createElement('figcaption')
        figEle.textContent = altText
        
        img.parentNode.appendChild(figEle)
      }
    }
  }
  
  return doc.childNodes.toString()
}